import React from 'react';
import LongText from '../Elements/LongText';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import moneyHelper from '../Helpers/moneyHelper';
import TpJobItem from './ThirdParty/TpJob/TpJobItem';
import RedirectLinkComponent from '../Elements/RedirectLinkComponent';

export default class TpClientInvoiceJobLine {
  constructor(item) {
    if (item === undefined) {
      this.TpClientInvoiceJobLineId = 0;
      this.TpJobId = '';
      this.ProjectName = '';
      this.ProjectId = '';
      this.LocationName = '';
      this.ThirdPartyJobId = '';
      this.LocationLevel2Id = '';
      this.LocationLevel3Id = '';
      this.LocationLevel4Id = '';
      this.LocationLevel5Id = '';
      this.LocationCountry = '';
      this.ClientFee = '';
      this.AdditionalClientFee = '';
      this.Reimbursement = '';
      this.Travel = '';
      this.Gaming = '';
      this.Misc = '';
      this.TpJobFieldworkOfficeName = '';
      this.FieldworkFee = '';
      this.TpJobEvaluatorName = '';
      this.JobStatus = '';
      this.ThirdPartyJobStatus = '';
      this.JobDate = '';
      this.CurrencyCode = '';
      this.TpJobPricingCurrencyCode = '';
      this.EvaluatorPaymentCurrencyCode = '';
      this.CampaignName = '';
      this.AdHocInvoiceGroup = '';
      this.TpSurveyName = '';
    } else {
      this.TpClientInvoiceJobLineId = item.tpClientInvoiceJobLineId;
      this.TpJobId = item.tpJobId;
      this.ProjectName = item.projectName;
      this.ProjectId = item.projectId;
      this.LocationName = item.locationName;
      this.ThirdPartyJobId = item.thirdPartyJobId;
      this.LocationLevel2Id = item.locationLevel2Id;
      this.LocationLevel3Id = item.locationLevel3Id;
      this.LocationLevel4Id = item.locationLevel4Id;
      this.LocationLevel5Id = item.locationLevel5Id;
      this.LocationCountry = item.locationCountry;
      this.ClientFee = item.clientFee;
      this.AdditionalClientFee = item.additionalClientFee;
      this.Reimbursement = item.reimbursement;
      this.Travel = item.travel;
      this.Gaming = item.gaming;
      this.Misc = item.misc;
      this.TpJobFieldworkOfficeName = item.tpJobFieldworkOfficeName;
      this.FieldworkFee = item.fieldworkFee;
      this.TpJobEvaluatorName = item.tpJobEvaluatorFirstName + ' ' + item.tpJobEvaluatorLastName;
      this.ThirdPartyJobStatus = item.thirdPartyJobStatus;
      this.JobStatus = item.jobStatus;
      this.JobDate = item.jobDate;
      this.CurrencyCode = item.currencyCode;
      this.TpJobPricingCurrencyCode = item.tpJobPricingCurrencyCode;
      this.EvaluatorPaymentCurrencyCode = item.evaluatorPaymentCurrencyCode;
      this.CampaignName = item.campaignName;
      this.AdHocInvoiceGroup = item.adHocInvoiceGroup;
      this.TpSurveyName = item.tpSurveyName;
    }
    this.Selected = false;
  }

  static MoneyFields = ['ClientFee', 'AdditionalClientFee', 'Reimbursement', 'Travel', 'Gaming', 'Misc'];
  static DateFields = ['JobDate'];
  static Currency() {
    return 'CurrencyCode';
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: TpClientInvoiceJobLine.getSelectedCellHeader,
        orderById: '',
        data: TpClientInvoiceJobLine.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      {
        label: 'Project',
        orderById: 'ProjectName',
        data: TpClientInvoiceJobLine.getProjectCellContent,
        minWidth: 40,
      },
      { label: 'Project ID', orderById: 'ProjectId', data: 'ProjectId', minWidth: 20 },
      { label: 'Survey', orderById: 'TpSurveyName', data: 'TpSurveyName', minWidth: 40 },
      {
        label: 'Location',
        orderById: 'LocationName',
        data: TpClientInvoiceJobLine.getLocationCellContent,
        minWidth: 40,
      },
      { label: 'Job ID', orderById: 'ThirdPartyJobId', data: TpClientInvoiceJobLine.idFunction, minWidth: 20 },
      {
        label: 'Ad-Hoc Invoice Group',
        orderById: 'AdHocInvoiceGroup',
        data: 'AdHocInvoiceGroup',
        minWidth: 50,
      },
      {
        label: 'Campaign',
        orderById: 'CampaignName',
        data: 'CampaignName',
        minWidth: 50,
      },
      {
        label: 'Country',
        orderById: 'LocationCountry',
        data: 'LocationCountry',
        minWidth: 10,
      },
      { label: 'ClientFee', orderById: 'ClientFee', data: 'ClientFee', minWidth: 10 },
      { label: 'Addit. Fee', orderById: 'AdditionalClientFee', data: 'AdditionalClientFee', minWidth: 10 },
      { label: 'Reimb', orderById: 'Reimbursement', data: 'Reimbursement', minWidth: 10 },
      { label: 'Travel', orderById: 'Travel', data: 'Travel', minWidth: 10 },
      { label: 'Gaming', orderById: 'Gaming', data: 'Gaming', minWidth: 10 },
      { label: 'Misc', orderById: 'Misc', data: 'Misc', minWidth: 10 },
      {
        label: 'FW Office',
        orderById: 'TpJobFieldworkOfficeName',
        data: TpClientInvoiceJobLine.getFieldworkOfficeCellContent,
        minWidth: 30,
      },
      {
        label: 'FW Fee',
        orderById: 'FieldworkFee',
        data: (item) => moneyHelper.toMoneyFormat(item.FieldworkFee, item.TpJobPricingCurrencyCode),
        minWidth: 10,
      },
      {
        label: 'Evaluator',
        orderById: 'TpJobEvaluatorName',
        data: TpClientInvoiceJobLine.getEvaluatorCellContent,
        minWidth: 40,
      },
      { label: 'JobStatus', orderById: 'JobStatus', data: 'JobStatus', minWidth: 20 },
      { label: 'TP. Status', orderById: 'ThirdPartyJobStatus', data: TpJobItem.getStatusCellContent, minWidth: 20 },
      { label: 'Completed On', orderById: 'JobDate', data: 'JobDate', minWidth: 30 },
    ];
  }

  static getProjectCellContent(item) {
    return (
      <LongText
        text={item.ProjectName ? item.ProjectName : ' '}
        maxLength={15}
      />
    );
  }

  static getLocationCellContent(item) {
    return (
      <LongText
        text={item.LocationName ? item.LocationName : ' '}
        maxLength={15}
      />
    );
  }

  static getLevel2CellContent(item) {
    return (
      <LongText
        text={item.LocationLevel2Id ? item.LocationLevel2Id : ' '}
        maxLength={8}
      />
    );
  }

  static getLevel3CellContent(item) {
    return (
      <LongText
        text={item.LocationLevel3Id ? item.LocationLevel3Id : ' '}
        maxLength={8}
      />
    );
  }

  static getLevel4CellContent(item) {
    return (
      <LongText
        text={item.LocationLevel4Id ? item.LocationLevel4Id : ' '}
        maxLength={8}
      />
    );
  }

  static getLevel5CellContent(item) {
    return (
      <LongText
        text={item.LocationLevel5Id ? item.LocationLevel5Id : ' '}
        maxLength={8}
      />
    );
  }

  static idFunction(item) {
    return (
      <RedirectLinkComponent
        isFigmaStyle={true}
        path='tpjobs'
        tooltipText={item.ThirdPartyJobId}
        text={item.ThirdPartyJobId}
        keyValuePairs={[{ key: 'TpJobId', value: item.TpJobId }]}
      />
    );
  }

  static getEvaluatorCellContent(item) {
    return (
      <LongText
        text={item.TpJobEvaluatorName ? item.TpJobEvaluatorName : ' '}
        maxLength={10}
      />
    );
  }

  static getFieldworkOfficeCellContent(item) {
    return (
      <LongText
        text={item.TpJobFieldworkOfficeName ? item.TpJobFieldworkOfficeName : ' '}
        maxLength={10}
      />
    );
  }
  static getSelectedCellHeader(item) {
    return (
      <div>
        <input
          type='checkbox'
          checked={TpClientInvoiceJobLine.selectedStatus()}
          onChange={(e) => {
            TpClientInvoiceJobLine.clickOnGlobalSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }
  static getSelectedCellContent(item) {
    return (
      <div className='text-center'>
        <input
          type='checkbox'
          checked={item.Selected}
          onChange={(e) => {
            TpClientInvoiceJobLine.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static clickOnGlobalSelect(item, selected) {}

  static clickOnSelect(item, selected) {}

  static selectedStatus() {
    return false;
  }
}
